"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoPanel = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var logo_1 = require("../logo");
var LogoPanel = function (props) {
    return (react_1.default.createElement(PanelPane, __assign({}, props),
        react_1.default.createElement(LogoPane, null,
            react_1.default.createElement(logo_1.Logo, null)),
        react_1.default.createElement(BodyPane, null, props.children)));
};
exports.LogoPanel = LogoPanel;
var PanelPane = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  box-shadow: ", ";\n\n  background: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  box-shadow: ", ";\n\n  background: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"])), function (props) { return props.width ? "".concat(props.width, "px") : undefined; }, function (props) { return props.theme.standard.boxShadow; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.borderRadius.all; });
var LogoPane = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 0 0 60px;\n\n  background: ", ";\n"], ["\n  flex: 0 0 60px;\n\n  background: ", ";\n"])), function (props) { return props.theme.colors.red1; });
var BodyPane = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-height: calc(100% - 60px);\n  overflow-y: scroll;\n  padding: 20px 30px;\n  box-sizing: border-box;\n"], ["\n  max-height: calc(100% - 60px);\n  overflow-y: scroll;\n  padding: 20px 30px;\n  box-sizing: border-box;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
